import React from 'react';
import { Modal as CustomModal } from '@appkit4/react-components/modal';

interface ModalProps {
    visible: boolean;
    title: string;
    onClose: () => void;
    children: React.ReactNode;
    modalStyle?: React.CSSProperties;
    /** Appkit focuses the first control on open; set false to open with nothing highlighted. */
    initialFocus?: boolean;
}

const Modal = ({
    visible,
    title,
    onClose,
    children,
    modalStyle,
    initialFocus = true,
}: ModalProps) => {
    return (
        <CustomModal
            visible={visible}
            onClose={onClose}
            title={title}
            ariaLabel={'modal demo'}
            onCancel={onClose}
            modalStyle={modalStyle}
            initialFocus={initialFocus}
            footerStyle={{
                paddingTop: '8px',
                marginTop: '-8px',
                minHeight: '64px',
            }}
            icons={''}
            footNote={''}
            bodyStyle={{ minHeight: '92px' }}
        >
            {children}
        </CustomModal>
    );
};
export default Modal;
